import {
	Typography,
	Grid,
	Stack,
	MenuItem,
	Box,
	InputAdornment,
	IconButton,
	Dialog,
	Snackbar,
	Checkbox,
	DialogTitle,
	DialogContent,
	DialogContentText,
	DialogActions,
	TextField,
	Alert,
} from "@mui/material";
import React from "react";
import { useState, useEffect, useMemo, useRef } from "react";
import { StyledTextBoxv2 } from "../../components/ui/TextBox";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import {
	BlackOutlinedButton,
	GreenContainedButton,
	TextButton,
	LightBlueContainedButton,
} from "../../components/ui/Buttons";
import "react-phone-input-2/lib/style.css";
import "./style.css";
import PhoneInput from "react-phone-input-2";
import validator from "validator";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { SellerSignUp, GenerateOtpCode, VerifyOtpCode } from "../../services/auth.services";
import { GetMarketplace } from "../../services/markeplace.services";
import { AMAZON_APPLICATION_ID } from "../../utils/constants";
import { geocodeByAddress } from "react-google-places-autocomplete";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useNavigate } from "react-router-dom";
import countryList from "react-select-country-list";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { REACT_APP_GOOGLE_API_KEY } from "../../utils/constants";

const boxStyle = {
	background: "#FFFFFF",
	p: 3,
	boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.04)",
	borderRadius: "10px",
};

export default function PersonalInfo({ updateStep }) {
	const [userInfo, setUserInfo] = useState({
		country: "",
		currency: "USD",
		email: "",
		firstName: "",
		lastName: "",
		address: "",
		state: "",
		city: "",
		timezone: "UTC-4 New York, United States",
		zipCode: "",
	});

	const [inputAddress, setInputAddress] = useState(null);
	const [contactNo, setContactNo] = useState();
	const [password, setPassword] = useState("");
	const [confirmPassword, setPasswordConfirm] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);
	const [errorCheckFirstName, setErrorCheckFirstName] = useState(false);
	const [errorCheckLastName, setErrorCheckLastName] = useState(false);
	const [errorCheckContactNo, setErrorCheckContactNo] = useState(false);
	const [errorCheckEmail, setErrorCheckEmail] = useState(false);
	const [errorCheckPassword, setErrorCheckPassword] = useState(false);
	const [errorCheckPasswordConfirm, setErrorCheckPasswordConfirm] =
		useState(false);
	const [errorCheckCity, setErrorCheckCity] = useState(false);
	const [errorCheckState, setErrorCheckState] = useState(false);
	const [errorCheckCountry, setErrorCheckCountry] = useState(false);
	const [errorCheckAddress, setErrorCheckAddres] = useState(false);
	const [errorCheckZipCode, setErrorCheckZipCode] = useState(false);
	const [emailMessage, setEmailMessage] = useState("");
	const [passwordMessage, setPasswordMessage] = useState("");
	const [passwordConfirmMessage, setPasswordConfirmMessage] = useState("");
	const [snackBarAlert, setSnackBarAlert] = useState(false);
	const [snackBarMessage, setSnackBarMessage] = useState("");
	const [open, setOpen] = useState(false);
	const [openConfirmation, setOpenConfirmation] = useState(false);
	const [openOtpModal, setOpenOtpModal] = useState(false);
	const [otpResponse, setOtpResponse] = useState('');
	const [otp, setOtp] = useState(Array(6).fill(""));
	const [amazonCallbackUri, setAmazonCallbackUri] = useState({});
	const [pendingUserData, setPendingUserData] = useState(null);
	const inputsRef = useRef([]);

	// Marketplace selection state (for Amazon callback flow)
	const [openMarketplaceDialog, setOpenMarketplaceDialog] = useState(false);
	const [marketplaces, setMarketplaces] = useState(null);
	const [selectedMarketplacesId, setSelectedMarketplacesId] = useState('placeholder');
	// const [marketplaceAuthUrl, setMarketplaceAuthUrl] = useState(null);
	const [marketplaceName, setMarketplaceName] = useState('');
	const [disableMarketplaceButton, setDisableMarketplaceButton] = useState(true);
	const [openMarketplaceConfirm, setOpenMarketplaceConfirm] = useState(false);

	const [useGoogleAutocomplete, setUseGoogleAutocomplete] = useState(true);
	const addressAPIKey = REACT_APP_GOOGLE_API_KEY;
	const countryOptions = useMemo(() => countryList().getData(), []);

	const navigate = useNavigate();

	useEffect(() => {
		const currentUrl = window.location.href;
		const urlParams = new URLSearchParams(currentUrl.split("?")[1]);
		const params = {};

		for (const [key, value] of urlParams.entries()) {
			params[key] = value;
		}

		setAmazonCallbackUri(params);
	}, []);

	useEffect(() => {
		if (inputAddress) {
			geocodeByAddress(inputAddress.label).then((place) => {
				let updatedUserInfo = { ...userInfo, address: inputAddress.label };

				for (var i = 0; i < place[0].address_components.length; i++) {
					var addressType = place[0].address_components[i].types[0];

					switch (addressType) {
						case "locality":
							updatedUserInfo.city = place[0].address_components[i].long_name;
							break;
						case "administrative_area_level_1":
							updatedUserInfo.state = place[0].address_components[i].long_name;
							break;
						case "country":
							updatedUserInfo.country =
								place[0].address_components[i].long_name;
							break;
						case "postal_code":
							updatedUserInfo.zipCode =
								place[0].address_components[i].long_name;
							break;
						default:
							break;
					}
				}

				setUserInfo(updatedUserInfo); // Update state once after loop
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [inputAddress]);

	const handleClose = () => {
		localStorage.clear();
		navigate("/login");
		setOpen(false);
	};

	const handleCloseConfirmation = () => {
		setOpenConfirmation(false);
	};

	const handleConfirmation = (e) => {
		e.preventDefault();

		let error = false;

		var letters = new RegExp(
			"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$"
		);

		if (userInfo.email === "" || userInfo.email === null) {
			error = true;
			setErrorCheckEmail(true);
		} else {
			setErrorCheckEmail(false);
		}

		if (validator.isEmail(userInfo.email)) {
			setEmailMessage("");
			setErrorCheckEmail(false);
		} else {
			setEmailMessage(
				userInfo.email === "" ? "Email is required" : "Enter a valid email"
			);
			setErrorCheckEmail(true);
			error = true;
		}

		if (password === "" || password === null) {
			error = true;
			setErrorCheckPassword(true);
		} else {
			setErrorCheckPassword(false);
		}

		if (password.length < 8) {
			error = true;
			setErrorCheckPassword(true);
			setPasswordMessage("Passwords length need to be more than 8 Characters");
		} else {
			setErrorCheckPassword(false);
			setPasswordMessage("");
		}

		if (!letters.test(password)) {
			error = true;
			setErrorCheckPassword(true);
			setPasswordMessage(
				"To become strong password, it must contain number, special character, capital and simple letters"
			);
		} else {
			setErrorCheckPassword(false);
			setPasswordMessage("");
		}

		if (confirmPassword !== password) {
			error = true;
			setPasswordConfirmMessage("Passwords don't match");
			setErrorCheckPasswordConfirm(true);
		} else {
			setPasswordConfirmMessage("");
			setErrorCheckPasswordConfirm(false);
		}

		if (userInfo.firstName === null || userInfo.firstName === "") {
			setErrorCheckFirstName(true);
			error = true;
		} else {
			setErrorCheckFirstName(false);
		}

		if (userInfo.lastName === null || userInfo.lastName === "") {
			setErrorCheckLastName(true);
			error = true;
		} else {
			setErrorCheckLastName(false);
		}

		const phoneNumber = parsePhoneNumberFromString(`+${contactNo}` || "");

		if (!phoneNumber || !phoneNumber.isValid()) {
			setErrorCheckContactNo(true);
			error = true;
		} else {
			setErrorCheckContactNo(false);
		}

		if (
			userInfo.city === null ||
			userInfo.city === "" ||
			userInfo.city === undefined
		) {
			setErrorCheckCity(true);
			error = true;
		} else {
			setErrorCheckCity(false);
		}

		if (
			userInfo.state === null ||
			userInfo.state === "" ||
			userInfo.state === undefined
		) {
			setErrorCheckState(true);
			error = true;
		} else {
			setErrorCheckState(false);
		}

		if (
			userInfo.zipCode === null ||
			userInfo.zipCode === "" ||
			userInfo.zipCode === undefined
		) {
			setErrorCheckZipCode(true);
			error = true;
		} else {
			setErrorCheckZipCode(false);
		}

		if (
			userInfo.country === null ||
			userInfo.country === "" ||
			userInfo.country === undefined
		) {
			setErrorCheckCountry(true);
			error = true;
		} else {
			setErrorCheckCountry(false);
		}

		if (
			userInfo.address === null ||
			userInfo.address === "" ||
			userInfo.address === undefined
		) {
			setErrorCheckAddres(true);
			error = true;
		} else {
			setErrorCheckAddres(false);
		}

		if (!error) {
			setOpenConfirmation(true);
		}
	};

	const handleUpdate = () => {
		const value = {
			...userInfo,
			contactNo,
			password,
			confirmPassword,
		};

		try {
			// Scenario 1: amazonCallbackUri is present - trigger OTP first
			if (amazonCallbackUri && Object.keys(amazonCallbackUri).length > 0) {
				setPendingUserData(value);
				const payload = {
					email: userInfo.email,
					flowType: 0
				};
				GenerateOtpCode(payload).then(({ response, result, error }) => {
					if (error || !response.ok) {
						let message = 'Something went wrong';

						if (response.status === 404) {
							message = 'User not found.';
						} else if (response.status === 401) {
							message = 'The email you entered is incorrect.';
						} else if (response.status === 409) {
							message = 'User already exists. Please login to your account.';
							setOpenOtpModal(false);
							setOpenConfirmation(false);
						} else if (error) {
							message = result?.message || 'Something went wrong try refreshing.';
						}

						setSnackBarAlert(true);
						setSnackBarMessage(message);
						return;
					}

					result.then((row) => {
						setOtpResponse(row.status);
						handleClickOpenOtpModal();
					});
				});
			} else {
				// Scenario 2: No amazonCallbackUri - trigger SellerSignUp directly
				SellerSignUp(value).then((data) => {
					if (data.ok) {
						localStorage.setItem("personalInfo", JSON.stringify(value));
						setOpen(true);
					} else if (data.status === 500 || data.status === 417) {
						setSnackBarAlert(true);
						setSnackBarMessage("This email address is already registered. Please sign in or use a different email to continue");
					} else if (data.status === 400) {
						setSnackBarAlert(true);
						setSnackBarMessage("Please fill all fields");
					}
				});
			}
		} catch (error) {
			setSnackBarAlert(true);
			setSnackBarMessage("Something went wrong please try again");
			console.error("Error", error);
		}
	};

	const handleClickOpenOtpModal = () => {
		setTimeout(() => {
			inputsRef.current[0]?.focus();
		}, 100);
		setOpenOtpModal(true);
	};

	const handleCloseOtpModal = () => {
		setOtp(Array(6).fill(""));
		setOpenOtpModal(false);
	};

	const handleChange = (e, index) => {
		let value = e.target.value;

		if (!/^\d$/.test(value)) {
			value = "";
		}

		const newOtp = [...otp];
		newOtp[index] = value;
		setOtp(newOtp);

		if (value && index < 5) {
			inputsRef.current[index + 1].focus();
		}
	};

	const handleKeyDown = (e, index) => {
		if (e.key === "Backspace" && !e.target.value && index > 0) {
			inputsRef.current[index - 1].focus();
		}
	};

	const handlePaste = (e) => {
		e.preventDefault();
		const pasteData = e.clipboardData.getData("text").trim();

		if (!/^\d+$/.test(pasteData)) return;

		const pasteDigits = pasteData.slice(0, 6).split("");
		const newOtp = [...otp];

		pasteDigits.forEach((digit, i) => {
			newOtp[i] = digit;
			if (inputsRef.current[i]) {
				inputsRef.current[i].value = digit;
			}
		});

		setOtp(newOtp);

		const lastIndex = pasteDigits.length - 1;
		if (lastIndex >= 0 && lastIndex < 6) {
			inputsRef.current[lastIndex].focus();
		}
	};

	const handleSubmitOtpModal = (e) => {
		e.preventDefault();
		const payload = {
			email: userInfo.email,
			otpNumber: otp.join("")
		};

		if (otp.join("") === "" || otp.join("") === null) {
			setSnackBarAlert(true);
			setSnackBarMessage('Something went wrong');
		} else {
			VerifyOtpCode(payload).then(({ response, result, error }) => {
				if (error || !response.ok || result === false) {
					let message = 'The OTP you entered is incorrect. Please try again.';

					if (response.status === 404) {
						message = 'User not found.';
					} else if (response.status === 401) {
						message = 'The code you entered is incorrect.';
					} else if (error) {
						message = result?.message || 'Something went wrong try refreshing.';
					}

					setSnackBarAlert(true);
					setSnackBarMessage(message);
					return;
				}

				if (result === true) {
					setOpenOtpModal(false);
					// After OTP verification, call SellerSignUp with pendingUserData
					if (pendingUserData) {
						SellerSignUp(pendingUserData).then((data) => {
							if (data.ok) {
								localStorage.setItem("personalInfo", JSON.stringify(pendingUserData));
								// If amazonCallbackUri is present, open marketplace selection dialog
								if (amazonCallbackUri && amazonCallbackUri.amazonCallbackUri) {
									// Fetch marketplaces with platformId = 1 (Amazon)
									GetMarketplace(1).then((marketplaceData) => {
										setMarketplaces(marketplaceData);
										setOpenMarketplaceDialog(true);
									});
								} else {
									// Otherwise show email verification dialog
									setOpen(true);
								}
							} else if (data.status === 500 || data.status === 417) {
								setSnackBarAlert(true);
								setSnackBarMessage("This email address is already registered. Please sign in or use a different email to continue");
							} else if (data.status === 400) {
								setSnackBarAlert(true);
								setSnackBarMessage("Please fill all fields");
							}
						});
					}
				}
			});
		}
	};

	return (
		<div>
			<br></br>
			<Box sx={boxStyle}>
				<Stack
					direction="row"
					spacing={2}
					sx={{ color: "#093BA7" }}
					alignItems="center"
				>
					<FolderSharedIcon />
					<Typography variant="h5">
						Basic Information for Personal Profile
					</Typography>
				</Stack>

				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								First Name
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								error
								placeholder="Enter your First Name"
								value={userInfo.firstName}
								onChange={(e) => {
									setUserInfo({ ...userInfo, firstName: e.target.value });
									setErrorCheckFirstName(false);
								}}
							/>
							<Typography variant="body3" color="red">
								{errorCheckFirstName ? "First name required" : ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Last Name
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								error={errorCheckLastName ? true : false}
								fullWidth
								placeholder="Enter your Last Name"
								value={userInfo.lastName}
								onChange={(e) => {
									setUserInfo({ ...userInfo, lastName: e.target.value });
									setErrorCheckLastName(false);
								}}
							/>
							<Typography variant="body3" color="red">
								{errorCheckLastName ? "Last name required" : ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Currency
							</Typography>
							<StyledTextBoxv2 fullWidth value="USD ($)" disabled />
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Timezone
							</Typography>
							<StyledTextBoxv2
								fullWidth
								value="UTC-4 New York, United States"
								disabled
							/>
						</Grid>
					</Grid>
				</Grid>
			</Box>
			<br></br>
			<Box sx={boxStyle}>
				<Stack
					direction="row"
					spacing={2}
					sx={{ color: "#093BA7" }}
					alignItems="center"
				>
					<LocalPhoneIcon />
					<Typography variant="h5">Personal Contact Information</Typography>
				</Stack>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Contact Number
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>

							<PhoneInput
								country={"us"}
								autoFormat={true}
								value={contactNo}
								onChange={(val) => {
									setContactNo(val);
									if (errorCheckContactNo) setErrorCheckContactNo(false);
								}}
								onBlur={() => {
									const phoneNumber = parsePhoneNumberFromString(
										`+${contactNo}` || ""
									);
									if (!phoneNumber || !phoneNumber.isValid()) {
										setErrorCheckContactNo(true);
									}
								}}
							/>

							<Typography variant="body3" color="red">
								{errorCheckContactNo
									? contactNo === ""
										? "Contact number is required"
										: "Please enter a valid phone number for the selected country."
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Email
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								error={errorCheckEmail ? true : false}
								fullWidth
								placeholder="Enter your Email Address"
								value={userInfo.email}
								onChange={(e) => {
									setUserInfo({ ...userInfo, email: e.target.value });
									setErrorCheckEmail(false);
									setEmailMessage(
										userInfo.email === ""
											? "Email is required"
											: "Enter a valid email"
									);
								}}
							/>
							<Typography variant="body3" color="red">
								{userInfo.email === "" && emailMessage}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Password
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								error={errorCheckPassword ? true : false}
								fullWidth
								placeholder="Minimum 8 characters"
								value={password}
								onChange={(e) => {
									setPassword(e.target.value);
									setErrorCheckPassword(false);
									setPasswordMessage("");
									setPasswordConfirmMessage("");
								}}
								type={showPassword ? "text" : "password"}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={() => setShowPassword(!showPassword)}
												edge="end"
											>
												{showPassword ? (
													<VisibilityOutlinedIcon />
												) : (
													<VisibilityOffOutlinedIcon />
												)}
											</IconButton>
										</InputAdornment>
									),
								}}
							/>
							<Typography variant="body3" color="red">
								{password === "" && errorCheckPassword
									? "Password is required"
									: passwordMessage}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Confirm Password
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								error={errorCheckPasswordConfirm ? true : false}
								fullWidth
								placeholder="Minimum 8 characters"
								value={confirmPassword}
								type={showConfirmPassword ? "text" : "password"}
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton
												aria-label="toggle password visibility"
												onClick={() =>
													setShowConfirmPassword(!showConfirmPassword)
												}
												edge="end"
											>
												{showConfirmPassword ? (
													<VisibilityOutlinedIcon />
												) : (
													<VisibilityOffOutlinedIcon />
												)}
											</IconButton>
										</InputAdornment>
									),
								}}
								onChange={(e) => {
									setPasswordConfirm(e.target.value);
									setErrorCheckPasswordConfirm(false);
									setPasswordConfirmMessage("");
								}}
							/>
							<Typography variant="body3" color="red">
								{confirmPassword === "" && errorCheckPassword
									? "Confirm password is required"
									: passwordConfirmMessage}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2">
								Address
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<Stack direction="row" alignItems="center">
								<Checkbox
									checked={useGoogleAutocomplete}
									onClick={() => {
										setInputAddress(null);
										setUserInfo({ ...userInfo, address: "" });
										setUseGoogleAutocomplete(!useGoogleAutocomplete);
									}}
								/>
								<Typography variant="body2_light">
									Use Google Autocomplete
								</Typography>
							</Stack>

							{addressAPIKey && useGoogleAutocomplete ? (
								<GooglePlacesAutocomplete
									apiKey={addressAPIKey}
									selectProps={{
										value: inputAddress,
										onChange: setInputAddress,
										placeholder: "Search your address",
										styles: {
											control: (provided) => ({
												...provided,
												border: "none",
												borderRadius: "4px",
												height: "2.5em",
												background: "#F9F9FB",
												color: "#28282A",
											}),
											placeholder: (provided) => ({
												...provided,
												color: "#c2c2c4",
											}),
										},
									}}
								/>
							) : (
								<StyledTextBoxv2
									fullWidth
									value={userInfo.address}
									placeholder="Enter your address"
									onChange={(e) => {
										setUserInfo({ ...userInfo, address: e.target.value });
										setErrorCheckAddres(false);
									}}
								/>
							)}
							<Typography variant="body3" color="red">
								{userInfo.address === "" && errorCheckAddress
									? "Address is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								State / Province / Region
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your state, province, or region"
								value={userInfo.state}
								onChange={(e) => {
									setUserInfo({ ...userInfo, state: e.target.value });
									setErrorCheckState(false);
								}}
							/>
							<Typography variant="body3" color="red">
								{userInfo.state === "" && errorCheckState
									? "State / Province / Region is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Postal / ZIP Code
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your Postal or ZIP Code"
								value={userInfo.zipCode}
								onChange={(e) => {
									setUserInfo({ ...userInfo, zipCode: e.target.value });
									setErrorCheckZipCode(false);
								}}
							/>
							<Typography variant="body3" color="red">
								{userInfo.zipCode === "" && errorCheckZipCode
									? "Postal / ZIP Code is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<br></br>
				<Grid container justifyContent="flex-start">
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								City / Town
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								placeholder="Enter your city or town"
								value={userInfo.city}
								onChange={(e) => {
									setUserInfo({ ...userInfo, city: e.target.value });
									setErrorCheckCity(false);
								}}
							/>
							<Typography variant="body3" color="red">
								{userInfo.city === "" && errorCheckCity
									? "City / Town is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
					<Grid item xs={1} />
					<Grid item xs={5} container direction="row" alignItems="center">
						<Grid item xs={12}>
							<Typography variant="body2" color="neutral.letter_Black">
								Country
								<Typography component="span" sx={{ color: "red", ml: 0.5 }}>
									*
								</Typography>
							</Typography>
							<StyledTextBoxv2
								fullWidth
								value={userInfo.country}
								select
								onChange={(e) => {
									setUserInfo({ ...userInfo, country: e.target.value });
									setErrorCheckCountry(false);
								}}
							>
								<MenuItem value="1" disabled>
									Select Country
								</MenuItem>
								{countryOptions.map((data, index) => (
									<MenuItem value={data.label} key={index}>
										{data.label}
									</MenuItem>
								))}
							</StyledTextBoxv2>
							<Typography variant="body3" color="red">
								{userInfo.country === "" && errorCheckCountry
									? "Country is required"
									: ""}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
			</Box>
			<br></br>
			<Stack justifyContent="flex-end" alignItems="flex-end">
				<GreenContainedButton
					variant="contained"
					onClick={(e) => handleConfirmation(e)}
					endIcon={<ArrowForwardIosIcon />}
				>
					Next
				</GreenContainedButton>
			</Stack>
			<br></br>
			{(!amazonCallbackUri || Object.keys(amazonCallbackUri).length === 0) && (
				<Dialog
					open={open}
					onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<Box sx={{ p: 6 }}>
						<Typography variant="h1" textAlign="center">
							Email Verification Required
						</Typography>
						<br></br>
						<Typography variant="body1" textAlign="center">
							Thank you for providing your personal information. To proceed with
							onboarding, please verify your email address.
						</Typography>
						<br></br>
						<Typography variant="body1" textAlign="center">
							Please check your inbox for an email from VePay Inc. titled "VePay
							Inc. - Email Verification Link." Click the verification link
							provided to confirm your email address.
						</Typography>
						<br></br>
						<Typography variant="body1" textAlign="center">
							If you don't find the email, kindly check your spam or junk folders.
							For assistance, contact our support team at <b>support@vepay.io.</b>
						</Typography>
						<br></br>
						<Stack alignItems="center">
							<BlackOutlinedButton variant="outlined" onClick={handleClose}>
								Close
							</BlackOutlinedButton>
						</Stack>
					</Box>
				</Dialog>
			)}

			<Dialog
				open={openConfirmation}
				onClose={handleCloseConfirmation}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<Box sx={{ p: 6 }}>
					<Typography variant="h1" textAlign="center">
						Is This Your Correct Email?
					</Typography>
					<br></br>
					<Typography variant="body1" textAlign="center">
						Please double-check your email address to make sure it's correct{" "}
						<b>{userInfo.email}</b>.
					</Typography>
					<br></br>
					<Typography variant="body1" textAlign="center">
						We'll use this to verify your identity and keep your account secure.
					</Typography>
					<br></br>
					<Typography variant="body1" textAlign="center">
						If everything looks good, go ahead and confirm to continue with
						onboarding.
					</Typography>
					<br></br>
					<Stack
						alignItems="center"
						direction="row"
						spacing={2}
						justifyContent="center"
					>
						<BlackOutlinedButton onClick={(e) => handleUpdate(e)}>
							Confirm
						</BlackOutlinedButton>
						<BlackOutlinedButton
							variant="outlined"
							onClick={handleCloseConfirmation}
						>
							Close
						</BlackOutlinedButton>
					</Stack>
				</Box>
			</Dialog>

			<Dialog open={openOtpModal}>
				<DialogTitle>Verify Your Identity</DialogTitle>
				<DialogContent>
					<DialogContentText>
						For your security, we've sent a One Time Password (OTP) to <b>{userInfo.email}</b>.
						Please enter it below to continue.
					</DialogContentText>
					{otpResponse === 'OTP_ALREADY_EXIST' ? <Alert severity="info">An OTP was already sent. Please check your email.</Alert> : ''}
					{otpResponse === 'USER_NOT_FOUND' ? <Alert severity="error">We couldn't find an account with this email. Please check and try again.</Alert> : ''}
					<form onSubmit={(e) => handleSubmitOtpModal(e)} id="otp-subscription-form">
						<Stack spacing={2} mt={2}>
							<Typography variant="body2" color="neutral.letter_Black">
								Enter OTP
							</Typography>
							<Stack direction="row" spacing={2} justifyContent="center">
								{otp.map((digit, index) => (
									<TextField
										key={index}
										required
										inputRef={(el) => (inputsRef.current[index] = el)}
										type="text"
										value={digit}
										inputProps={{
											maxLength: 1,
											style: {
												textAlign: "center",
												fontSize: "1.5rem",
											},
											inputMode: "numeric",
										}}
										onChange={(e) => handleChange(e, index)}
										onKeyDown={(e) => handleKeyDown(e, index)}
										onPaste={handlePaste}
									/>
								))}
							</Stack>
						</Stack>
					</form>
				</DialogContent>
				<DialogActions>
					<TextButton variant="text" onClick={handleCloseOtpModal}>Cancel</TextButton>
					<LightBlueContainedButton variant="contained" type="submit" form="otp-subscription-form" disabled={otp.includes("")}>
						Continue
					</LightBlueContainedButton>
				</DialogActions>
			</Dialog>

			{/* Marketplace Selection Dialog (Amazon callback flow) */}
			<Dialog
				open={openMarketplaceDialog}
				onClose={() => {
					setOpenMarketplaceDialog(false);
					setSelectedMarketplacesId('placeholder');
					setDisableMarketplaceButton(true);
				}}
				aria-labelledby="marketplace-dialog-title"
				aria-describedby="marketplace-dialog-description"
			>
				<DialogTitle id="marketplace-dialog-title">
					Connect to your Amazon Marketplace
				</DialogTitle>
				<DialogContent>
					<br></br>
					<Stack>
						<Typography variant="body2" color="neutral.letter_Black">
							Marketplace
						</Typography>
						<StyledTextBoxv2
							fullWidth
							value={selectedMarketplacesId}
							select
							onChange={(event) => {
								setSelectedMarketplacesId(event.target.value);
								const value = marketplaces.find(item => item.id === event.target.value);
								// setMarketplaceAuthUrl(value.authEndpoint);
								setMarketplaceName(value.name);
								if (value.authEndpoint) {
									setDisableMarketplaceButton(false);
								}
							}}
						>
							<MenuItem disabled value="placeholder">
								<em>Select Marketplace</em>
							</MenuItem>
							{marketplaces?.map((data, index) => (
								<MenuItem value={data.id} key={index}>{data.name}</MenuItem>
							))}
						</StyledTextBoxv2>
					</Stack>
					<br></br>
				</DialogContent>
				<DialogActions>
					<TextButton variant="text" onClick={() => {
						setOpenMarketplaceDialog(false);
						setSelectedMarketplacesId('placeholder');
						setDisableMarketplaceButton(true);
					}}>Close</TextButton>
					<LightBlueContainedButton disabled={disableMarketplaceButton} variant="contained" onClick={() => setOpenMarketplaceConfirm(true)} autoFocus>
						Proceed
					</LightBlueContainedButton>
				</DialogActions>
			</Dialog>

			{/* Marketplace Confirmation Dialog (Amazon callback flow) */}
			<Dialog
				open={openMarketplaceConfirm}
				onClose={() => {
					setOpenMarketplaceConfirm(false);
					setSelectedMarketplacesId('placeholder');
					setDisableMarketplaceButton(true);
				}}
				aria-labelledby="marketplace-confirm-dialog-title"
				aria-describedby="marketplace-confirm-dialog-description"
			>
				<DialogContent>
					<br></br>
					<Stack spacing={1}>
						<Typography variant="body1">
							You have registered your business country as <b>{userInfo.country}</b> and are now connecting to the <b>Amazon {marketplaceName}</b> marketplace.
							Is this correct?
						</Typography>
						<Typography variant="body1">
							Please confirm: Is this the same country/region where your Amazon account is registered?
						</Typography>
						<Typography variant="body2_light">
							(Note: You must select the Amazon region that matches the country of your Amazon seller account)
						</Typography>
					</Stack>
					<br></br>
				</DialogContent>
				<DialogActions>
					<TextButton variant="text" onClick={() => {
						setOpenMarketplaceConfirm(false);
						setSelectedMarketplacesId('placeholder');
						setDisableMarketplaceButton(true);
					}}>Close</TextButton>
					<LightBlueContainedButton disabled={disableMarketplaceButton} variant="contained" onClick={() => setOpenMarketplaceConfirm(false)} autoFocus>
						<a
							href={`${amazonCallbackUri.amazonCallbackUri}?application_id=${AMAZON_APPLICATION_ID}&state=1-${localStorage.getItem("uniqueId")}-${selectedMarketplacesId}`}
							rel="noreferrer"
							className="text-link"
						>
							Confirm and Proceed
						</a>
					</LightBlueContainedButton>
				</DialogActions>
			</Dialog>

			<Snackbar
				open={snackBarAlert}
				onClose={() => setSnackBarAlert(false)}
				anchorOrigin={{ vertical: "top", horizontal: "left" }}
				sx={{ top: "0 !important", left: "0 !important" }}
				autoHideDuration={6000}
			>
				<Box
					onClose={() => setSnackBarAlert(false)}
					sx={{ width: "100vw", background: "#F33535", p: 0.5 }}
				>
					<Stack
						direction="row"
						spacing={2}
						sx={{
							width: "100%",
							textAlign: "center",
							alignItems: "center",
							justifyContent: "center",
							color: "#FFFFFF",
						}}
					>
						<CancelOutlinedIcon fontSize="small" />
						<Typography variant="body2">{snackBarMessage}</Typography>
					</Stack>
				</Box>
			</Snackbar>
		</div>
	);
}
